module.exports = __webpack_public_path__ + "img/clothing180.5d0ddbf5.jpg";